export const fieldUser = [
    {
        id:"firstName",
        name:"firstName", 
        label:"First Name",
        type:"input",
        inputType:"text",
        errorMessage: "first name"
    },
    {
        id:"lastName",
        name:"lastName", 
        label:"Last Name",
        type:"input",
        inputType:"text",
        errorMessage: "last name"
    },
    {
        id:"email",
        name:"email", 
        label:"Email",
        type:"input",
        inputType:"text",
        errorMessage: "valid email address"
    },
    {
        id:"roleAssignment",
        name:"roleAssignment", 
        label:"Role Assignment",
        placeHolder: "Role",
        type:"select",
        errorMessage: "role assignment",
        data: [
            {value:"SUPER_ADMIN", label:"ADMIN"},
            {value:"MODERATOR", label:"VIEWER"},
        ]
    },    
    {
        id:"status",
        name:"status", 
        label:"Status",
        placeHolder: "Status",
        type:"select",
        data: [
            {value:"ACTIVE", label:"Active"},
            {value:"INACTIVE", label:"Inactive"},
            // {value:"PENDING", label:"Pending"},
        ]
    },    
]
